<div class="pnl-chart-container" [style.height.px]="chartHeightPx">
  @if (!(chartBars$ | async)) {
    <div class="loader-container">
      <mat-icon>
        <mat-spinner class="chart-loading-spinner" diameter="25"></mat-spinner>
      </mat-icon>
    </div>
  }
  @for (bar of chartBars$ | async; track bar) {
    <div class="pnl-chart-bar">
      <div [style.height.%]="bar?.negativeEmptySpaceBarSizePercent || 0"></div>
      <div [style.height.%]="bar?.profitBarSizePercent || 0" class="profit" [ngClass]="{ negative: bar.profit < 0 }"></div>
      <div [style.height.%]="bar?.positiveEmptySpaceBarSizePercent || 0"></div>
    </div>
  }
</div>
